export const SERVICE_ACCESS_MODES = [
  'OPEN',
  'LIMITED',
  'MAINTENANCE',
  'EMERGENCY',
];

export const NEW_INSTALL_BEHAVIORS = ['DENY', 'SIGNUP_WAITLIST'];

export const RESTRICTIVE_MODES = new Set(['LIMITED', 'MAINTENANCE', 'EMERGENCY']);

export function productionConfirmation(action, mode, environment = 'PROD', targetRevision = '') {
  return action === 'ROLLBACK'
    ? `ROLLBACK ${environment} ${targetRevision}`.trim()
    : `APPLY ${environment} ${mode}`;
}

export function modeSelectable(mode, availableModes) {
  if (!SERVICE_ACCESS_MODES.includes(mode)) return false;
  if (!Array.isArray(availableModes) || availableModes.length === 0) return true;
  const entry = availableModes.find((item) => (typeof item === 'string' ? item : item.mode) === mode);
  return typeof entry === 'string' ? true : Boolean(entry?.selectable);
}

export function actionValidation({ action, mode, reason, jira, expiresAt, messageKo, messageEn, confirmation, environment, targetRevision }) {
  if (String(reason || '').trim().length < 5) return 'reason';
  if (!/^[A-Z]+-[0-9]+$/.test(String(jira || '').trim())) return 'jira';
  if (action === 'APPLY' && RESTRICTIVE_MODES.has(mode) && !expiresAt) return 'expiry';
  if (!String(messageKo || '').trim() || !String(messageEn || '').trim()) return 'message';
  if (confirmation !== productionConfirmation(action, mode, environment, targetRevision)) return 'confirmation';
  return null;
}
